<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 28px !important;
  width: 100%;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/batch/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('picifanganbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('picifanganmingchen')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          v-if="utils.checkPower('web_basic_material_batch_create')"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2');
            setDefaultValue();
            getProcedureCode();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <!-- 操作插槽 -->
      <template #guizexiangqing="scope">
        <div style="display:flex">
          <p v-for="(detail, i) in scope.row.materialBatchDetails"><span v-if="i != 0">+</span>{{ $t(store.state.dictJsonAll['BAR_CODE_RULE_TYPE'][detail.ruleType]) }}</p>
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_basic_material_batch_property_batchInsert')"
              @click="
                yt.showEditDialog('xiangqing', scope.row, 'w2');
                setDetailsDefaultValue(scope.row);
                getProcedureCode();
              "
            >
              {{ $t('xiangqing') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              type="text"
              v-if="utils.checkPower('web_basic_material_batch_update')"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w2');
                setDefaultValue2(scope.row);
                getProcedureCode();
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_basic_material_batch_delete')" @click="yt.remove(scope.row, '/web/basic/material/batch/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xiangqing'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('picifanganbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('picifanganmingchen')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.isEnabled">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('picishuxing') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="detailsColumnsItem">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL>
                <el-button size="mini" @click="addDetailRow()" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
              </template>

              <template #mingchen="scope">
                <el-select v-model="scope.row.name" class="inputClass" size="mini" :max="1" clearable="false" :placeholder="$t('qingxuanze')">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </template>

              <template #shurukongzhi="scope">
                <el-select v-if="scope.row.name != 3" class="inputClass" v-model="scope.row.inputControl" size="mini" :max="1" clearable="false" :placeholder="$t('qingxuanze')">
                  <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </template>

              <template #chukuyanshou="scope">
                <el-switch active-value="1" inactive-value="0" v-model="scope.row.inboundAcceptance"> </el-switch>
              </template>

              <template #shouhuoyanshou="scope">
                <el-switch active-value="1" inactive-value="0" v-model="scope.row.outboundAcceptance"> </el-switch>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="deleteRow(scope._index)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/basic/material/batch/property/batchInsert', beforeDetailAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('picifanganbianma')" required>
                <el-input v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('picifanganmingchen')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.isEnabled">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('guizemingxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL>
                <el-button size="mini" @click="addRow()" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
              </template>

              <template #guizeleixing="scope">
                <yi_dictionary_select size="mini" class="inputClass" :max="1" clearable="false" :type="'BAR_CODE_RULE_TYPE'" :ids.sync="scope.row.ruleType"> </yi_dictionary_select>
              </template>

              <template #qishizhigeshi="scope">
                <el-input class="inputClass" v-show="scope.row.ruleType == 2" size="mini" maxlength="10" show-word-limit v-model="scope.row.input2"></el-input>
                <el-input class="inputClass" v-show="scope.row.ruleType == 3" size="mini" maxlength="10" show-word-limit v-model="scope.row.input3"></el-input>
                <el-input class="inputClass" v-show="scope.row.ruleType == 4" size="mini" maxlength="10" show-word-limit v-model="scope.row.input4"></el-input>
                <yi_dictionary_select class="inputClass" v-show="scope.row.ruleType == 5" size="mini" :max="1" clearable="false" :type="'TIMES_FORMAT'" :ids.sync="scope.row.input5"> </yi_dictionary_select>
                <yi_dictionary_select class="inputClass" v-show="scope.row.ruleType == 6" size="mini" :max="1" clearable="false" :type="'SEPARATOR'" :ids.sync="scope.row.input6"> </yi_dictionary_select>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" @click="move(scope._index, 1)">{{ $t('shangyi') }}</el-button>
                  </el-col>
                  <el-col :span="0.1">
                    <el-button type="text" @click="move(scope._index, 2)">{{ $t('xiayi') }}</el-button>
                  </el-col>

                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="deleteRow(scope._index)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/basic/material/batch/create', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
              <el-form-item :label="$t('picifanganbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('picifanganmingchen')" required>
                <el-input v-model="yt.editObj.name"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.isEnabled">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div style="margin-top: 8px;margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
            {{ $t('guizemingxi') }}
          </div>
          <div style="flex:1;">
            <yi_curd_table :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL>
                <el-button size="mini" @click="addRow()" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
              </template>

              <template #guizeleixing="scope">
                <yi_dictionary_select class="inputClass" size="mini" :max="1" clearable="false" :type="'BAR_CODE_RULE_TYPE'" :ids.sync="scope.row.ruleType"> </yi_dictionary_select>
              </template>

              <template #qishizhigeshi="scope">
                <el-input v-show="scope.row.ruleType == 2" size="mini" maxlength="10" show-word-limit v-model="scope.row.input2"></el-input>
                <el-input v-show="scope.row.ruleType == 3" size="mini" maxlength="10" show-word-limit v-model="scope.row.input3"></el-input>
                <el-input v-show="scope.row.ruleType == 4" size="mini" maxlength="10" show-word-limit v-model="scope.row.input4"></el-input>
                <yi_dictionary_select v-show="scope.row.ruleType == 5" size="mini" :max="1" clearable="false" :type="'TIMES_FORMAT'" :ids.sync="scope.row.input5"> </yi_dictionary_select>
                <yi_dictionary_select v-show="scope.row.ruleType == 6" size="mini" :max="1" clearable="false" :type="'SEPARATOR'" :ids.sync="scope.row.input6"> </yi_dictionary_select>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" @click="move(scope._index, 1)">{{ $t('shangyi') }}</el-button>
                  </el-col>
                  <el-col :span="0.1">
                    <el-button type="text" @click="move(scope._index, 2)">{{ $t('xiayi') }}</el-button>
                  </el-col>

                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="deleteRow(scope._index)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/basic/material/batch/update', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
// import importExcel from './import_excel'
export default {
  name: 'web_basic_materail_batch_list',
  components: {
    // importExcel
  },
  data() {
    return {
      moveButton: true,
      currentRow: null,
      value: '',
      labelRuleDetailsVOList: [],
      multipleSelection: [],
      show: false,
      codeAndDesc: '',
      options: [
        {
          value: '1',
          label: this.$t('shengchanriqi')
        },
        {
          value: '2',
          label: this.$t('shixiaoriqi')
        },
        {
          value: '3',
          label: this.$t('shouhuoriqi')
        }
      ],
      options2: [
        {
          value: '1',
          label: this.$t('bishu')
        },
        {
          value: '2',
          label: this.$t('kexuan')
        }
      ],
      detailsColumnsItem: [
        {
          label: 'paixu',
          type: 'index'
        },
        {
          label: 'mingchen',
          type: 'slot'
        },
        {
          label: 'shurukongzhi',
          type: 'slot'
        },
        {
          label: 'chukuyanshou',
          type: 'slot'
        },
        {
          label: 'shouhuoyanshou',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      columnsItem: [
        {
          label: 'paixu',
          type: 'index'
        },
        {
          label: 'guizeleixing',
          type: 'slot'
        },
        {
          label: 'qishizhigeshi',
          type: 'slot'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      columns: [
        {
          label: 'picifanganbianma',
          prop: 'code'
        },
        {
          label: 'picifanganmingchen',
          prop: 'name'
        },
        {
          label: 'shifouqiyong',
          prop: 'isEnabled',
          type: 'bool',
          iln18: ['shi', 'fou'],
          width: 80
        },
        {
          label: 'guizexiangqing',
          type: 'slot',
          prop: 'info'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.utils.event_hub.$on('QUALITY_MANAGEMENT_METHOD_REFRESH', () => {
        this.yt.get(1);
      });
    }, 300);
  },
  methods: {
    move(index, type) {
      console.log('选中', index);
      if (type == 1) {
        /* //上移
					let index = 0;
					for (let i = 0; i < this.$refs.yt2.list.length; i++) {
						if (this.$refs.yt2.list[i].checked == true) {
							index = i
							break
						}
					} */
        console.log('索引', index);
        if (index > 0) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index - 1];
          // temp.checked = true
          tempsArr[index - 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index - 1]);
        }
      }
      if (type == 2) {
        /* //下移 
					let index = 0;
					for (let i = 0; i < this.$refs.yt2.list.length; i++) {
						if (this.$refs.yt2.list[i].checked == true) {
							index = i
							break
						}
					} */
        console.log('索引', index);
        if (index < this.$refs.yt2.list.length - 1) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index + 1];
          tempsArr[index + 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index + 1]);
        }
      }
    },
    /* setCurrent(row) {
				this.$refs.singleTable.setCurrentRow(row);
			}, */
    addRow(rows) {
      console.log('增加一行', rows);
      this.$refs.yt2.list.push({
        ruleType: '',
        initialValue: ''
      });
    },
    addDetailRow(rows) {
      console.log('增加一行', rows);
      this.$refs.yt2.list.push({
        name: '',
        inputControl: '',
        mainId: 0,
        inboundAcceptance: '',
        outboundAcceptance: ''
      });
    },
    /* handleCurrentChange(val) {
				this.currentRow = val;
				console.log("选中", this.currentRow)

				//其他的取消勾选
				for (let i = 0; i < this.labelRuleDetailsVOList.length; i++) {
					this.labelRuleDetailsVOList[i].checked = false
				}
				this.currentRow.checked = true
				this.moveButton = false
			}, */
    deleteRow(index, rows) {
      this.$refs.yt2.list.splice(index, 1);
    },
    /* toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
			}, */
    setDefaultValue() {
      this.yt.editObj.isEnabled = 1;
      this.labelRuleDetailsVOList = [];
      this.moveButton = true;
    },
    setDefaultValue2(row) {
      this.moveButton = true;
      this.currentRow = null;
      let tmp = this.utils.copy(row.materialBatchDetails);
      console.log('编辑预处理', tmp);
      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i].ruleType == '2') {
          tmp[i].input2 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '3') {
          tmp[i].input3 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '4') {
          tmp[i].input4 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '5') {
          tmp[i].input5 = tmp[i].initialValue;
        }
        if (tmp[i].ruleType == '6') {
          tmp[i].input6 = tmp[i].initialValue;
        }
      }

      this.$nextTick(() => {
        this.$refs.yt2.list = tmp;
      });
    },
    setDetailsDefaultValue(row) {
      let tmp = this.utils.copy(row.basicMaterialBatchPropertys);
      console.log('编辑预处理', tmp);
      this.$nextTick(() => {
        this.$refs.yt2.list = tmp;
      });
    },
    getProcedureCode() {
      this.http.get('/web/label/rule/page').then(res => {
        if (this.yt.editObj.action == 'xinzeng') {
        }
      });
    },
    beforeDetailAdd(params) {
      let list = this.$refs.yt2.list;
      for (let i = 0; i < list.length; i++) {
        list[i].mainId = this.yt.editObj.id;
        if (list[i].inboundAcceptance == '0' && list[i].outboundAcceptance == '0') {
          this.utils.errorMessage(this.$t('bixubaohanyixiang'));
          return false;
        }
        /* if (list[i].inboundAcceptance == '1' && list[i].outboundAcceptance == '1') {
						this.utils.errorMessage(this.$t('bixubaohanyixiang'))
						return
					} */
      }
      return list;
    },
    beforeNewAdd(params) {
      console.log('提交预处理', this.$refs.yt2.list);

      let basicMaterialBatchDetailsVOS = this.$refs.yt2.list;
      for (let i = 0; i < basicMaterialBatchDetailsVOS.length; i++) {
        basicMaterialBatchDetailsVOS[i].sort = i + 1;
        if (basicMaterialBatchDetailsVOS[i].ruleType == '2') {
          basicMaterialBatchDetailsVOS[i].initialValue = basicMaterialBatchDetailsVOS[i].input2;
        }
        if (basicMaterialBatchDetailsVOS[i].ruleType == '3') {
          basicMaterialBatchDetailsVOS[i].initialValue = basicMaterialBatchDetailsVOS[i].input3;
        }
        if (basicMaterialBatchDetailsVOS[i].ruleType == '4') {
          basicMaterialBatchDetailsVOS[i].initialValue = basicMaterialBatchDetailsVOS[i].input4;
        }
        if (basicMaterialBatchDetailsVOS[i].ruleType == '5') {
          basicMaterialBatchDetailsVOS[i].initialValue = basicMaterialBatchDetailsVOS[i].input5;
        }
        if (basicMaterialBatchDetailsVOS[i].ruleType == '6') {
          basicMaterialBatchDetailsVOS[i].initialValue = basicMaterialBatchDetailsVOS[i].input6;
        }
      }
      params.materialBatchDetails = basicMaterialBatchDetailsVOS;
      return params;
    }
  }
};
</script>
